import { getQuestionConfigLimits } from 'sharedParts/config/blockConfig';

export default type => Object.keys(getQuestionConfigLimits(type));
